import Knowledgerouter from "./Knowledgerouter";
export default Knowledgerouter;
